/* eslint-disable react/no-unused-prop-types */
// Using props for styling
import React, { FC, useRef } from 'react';
import injectSheet from 'react-jss';
import styleSheet from './styles';

interface Props {
  classes?: any;
  text?: string;
  groupCount?: number | string;
  border?: string;
  backgroundColor?: string;
  textColor?: string;
  focusOnClick?: boolean;
  focusOnHover?: boolean;
}

const Pill: FC<Props> = (props: Props) => {
  const { classes, text, groupCount, focusOnClick, focusOnHover } = props;

  const divFocus = useRef(null);

  const handleClick = () => {
    if (focusOnClick) {
      divFocus.current.focus();
    }
  };

  const handleKeyDown = (e: any) => {
    const code = e.charCode || e.keyCode;
    if (code === 27) {
      divFocus.current.blur();
    }
  };

  const handleHover = () => {
    if (focusOnHover) {
      divFocus.current.focus();
    }
  };

  return (
    <div
      className={classes.container}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      onMouseEnter={handleHover}
      tabIndex={0}
      ref={divFocus}
      role="button"
      data-testid="pill"
    >
      <div className={classes.pill} data-testid="classes.pill">
        {text && (
          <span className={classes.pillText} data-testid="classes.pillText">
            {text}
          </span>
        )}
        {groupCount > 0 && (
          <span className={classes.groupCount} data-testid="classes.groupCount">
            <span
              className={classes.groupCountText}
              data-testid="classes.groupCountText"
            >
              {groupCount}
            </span>
          </span>
        )}
      </div>
    </div>
  );
};

Pill.defaultProps = {
  classes: {},
  text: '',
  groupCount: 0,
  border: undefined,
  backgroundColor: undefined,
  textColor: undefined,
  focusOnClick: false,
  focusOnHover: false,
};

export default injectSheet(styleSheet)(Pill);
